const $ = jQuery.noConflict();
import Global from '../shared/global';
import Player from '@vimeo/player';

'use strict';
const Popup = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domTestimonialPopupBtn: $('.js-testimonials-box__wrap-link'),
	$domTestimonialPopupPopup: $('.js-testimonials-popup'),
	$domTestimonialPopupInner: $('.js-testimonials-popup__inner'),
	$domTestimonialPopupCloseIcon: $('.js-testimonials-popup__close'),
	$domGalleryDetailLink: $('.js-slider-gallery__box, .js-gallery-boxes__box'),
	$domGalleryDetailPopup: $('.gallery-detail'),
	$domGalleryDetailClose: $('.gallery-detail__close'),
	classActive: 'is-active',
	classHasTransition: 'has-transition',
	classPreventScroll: 'prevent-scroll',

	/** @description Initialize */
	init: function() {
		this.sliderTestimonialPopupShow();
		this.sliderTestimonialPopupHide();
		this.closeMenuOnOusideContainerClick();
		Global.escKey(Popup.closePopup);
		this.openPopupGallery();
		this.closePopupGalleryIcon();
		Global.escKey(Popup.closePopupGallery);

		$(document).on('afterClose.fb', function(e, instance, slide) {
			const iframes = document.querySelectorAll('.js-video-block');

			iframes.forEach(iframe => {
				const player = new Player(iframe);

				// Mute the video and attempt to play
				player.setVolume(0).then(() => player.play()).catch(error => {
					console.error('Error playing the video:', error);
				});
			});
		});
	},

	sliderTestimonialPopupShow: function() {
		$(Popup.$domTestimonialPopupBtn).each(function(i, el) {
			$(el).on('click', function() {
				const popupNum = $(el).data('popup');
				Popup.$domBody.addClass(Popup.classPreventScroll);
				$(`.js-testimonials-popup-${popupNum}`).addClass(Popup.classActive);
				$(`.js-testimonials-popup-${popupNum}`).addClass(Popup.classHasTransition);
			});
		});
	},

	sliderTestimonialPopupHide: function() {
		Popup.$domTestimonialPopupCloseIcon.each(function(i, el) {
			$(el).on('click', function() {
				Popup.closePopup();
			});
		});
	},

	closePopup: function() {
		Popup.$domBody.removeClass(Popup.classPreventScroll);
		Popup.$domTestimonialPopupPopup.removeClass(Popup.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOusideContainerClick: function() {
		Popup.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (Popup.$domTestimonialPopupPopup.hasClass(Popup.classActive) && !Popup.$domTestimonialPopupInner.is(e.target) && Popup.$domTestimonialPopupInner.has(e.target).length === 0 && !Popup.$domTestimonialPopupCloseIcon.is(e.target)) {
				Popup.closePopup();
			}
		});
	},

	openPopupGallery: function() {
		Popup.$domGalleryDetailLink.each(function(i, el) {
			$(el).on('click', function() {
				Popup.$domBody.addClass(Popup.classPreventScroll);
				Popup.$domGalleryDetailPopup.addClass(Popup.classActive);
				Popup.$domGalleryDetailPopup.addClass(Popup.classHasTransition);
				let scrollPosition = 0;
				scrollPosition = $(window).scrollTop();
				Popup.$domBody.css('top', scrollPosition+'px');
			});
		});
	},

	closePopupGalleryIcon: function() {
		$('.gallery-detail__close').on('click', function() {
			const href = window.location.href.split('?')[0];
			history.replaceState(null, null, href);
			$('body').removeClass(Popup.classPreventScroll);
			$('.gallery-detail').removeClass(Popup.classActive);
			const videos = document.querySelectorAll('iframe');
			videos.forEach(i => {
				const source = i.src;
				i.src = '';
				i.src = source;
			});
			let videoBlock = $('.js-video-block').get(0);
			if (videoBlock && typeof videoBlock.play === 'function') {
				videoBlock.play();
			}
		});
		$('.js-gallery-arrow-right').on('click', function() {
			const videos = document.querySelectorAll('iframe');
			videos.forEach(i => {
				const source = i.src;
				i.src = '';
				i.src = source;
			});
		});
		$('.js-gallery-arrow-left').on('click', function() {
			const videos = document.querySelectorAll('iframe');
			videos.forEach(i => {
				const source = i.src;
				i.src = '';
				i.src = source;
			});
		});
	},

	closePopupGallery: function() {
		Popup.$domBody.removeClass(Popup.classPreventScroll);
		Popup.$domGalleryDetailPopup.removeClass(Popup.classActive);
		let scrollPosition = 0;
		scrollPosition = $(window).scrollTop();
		Popup.$domBody.css('top', scrollPosition+'px');

		const iframes = document.querySelectorAll('.js-video-block');
		iframes.forEach(iframe => {
        const player = new Player(iframe);

        player.play().catch(function(error) {
            console.error('Error playing the video:', error);
			});
		});
	},
};

export default Popup;
